module.exports = __webpack_public_path__ + "img/all_champs.2e2b952b.jpeg";